import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[appNoDblClick]'
})
export class NoDblClickDirective {

  constructor(private el: ElementRef) {
  }

  @HostListener('click', ['$event'])
  clickEvent() {
    const button = this.el.nativeElement;
    button.setAttribute('disabled', 'true');
    setTimeout(function () {
      button.removeAttribute('disabled');
    }, 2000);
  }

}
